import { render, staticRenderFns } from "./customer-supply-detail.vue?vue&type=template&id=7fa1b8e2"
import script from "./customer-supply-detail.vue?vue&type=script&lang=js"
export * from "./customer-supply-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports